export const colors = {
  accent: {
    50: "#F1F8F2",
    100: "#DCEEDE",
    500: "#2F7D3A",
    600: "#256A30",
    700: "#1C5125",
  },
  auto: { bg: "#F1F8F2", fg: "#1C5125", border: "#BFE0C4" },
  review: { bg: "#FFF7ED", fg: "#9A3412", border: "#FED7AA" },
  unmatched: { bg: "#FEF2F2", fg: "#991B1B", border: "#FECACA" },
} as const;

function hexToRgb(hex: string): [number, number, number] | null {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex.trim());
  if (!m) return null;
  const n = parseInt(m[1], 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}
function rgbToHex(r: number, g: number, b: number): string {
  return "#" + [r, g, b].map((v) => Math.max(0, Math.min(255, Math.round(v))).toString(16).padStart(2, "0")).join("");
}
function mix(hex: string, withHex: string, weight: number): string {
  const a = hexToRgb(hex), b = hexToRgb(withHex);
  if (!a || !b) return hex;
  return rgbToHex(a[0] * (1 - weight) + b[0] * weight, a[1] * (1 - weight) + b[1] * weight, a[2] * (1 - weight) + b[2] * weight);
}

export function derivePalette(primary: string) {
  return {
    50: mix(primary, "#ffffff", 0.92),
    100: mix(primary, "#ffffff", 0.82),
    500: primary,
    600: mix(primary, "#000000", 0.12),
    700: mix(primary, "#000000", 0.28),
  };
}

export function applyAccentPalette(primary: string | null | undefined) {
  const root = document.documentElement.style;
  const p = primary && hexToRgb(primary) ? derivePalette(primary) : colors.accent;
  root.setProperty("--accent-50", p[50]);
  root.setProperty("--accent-100", p[100]);
  root.setProperty("--accent-500", p[500]);
  root.setProperty("--accent-600", p[600]);
  root.setProperty("--accent-700", p[700]);
}
